import Transport from './transport-fetch';

const dataService = {
  headers: {
    apikey: 'SGUmO9vZplCwgKSKVtfYrQMN1j5IbAWq',
    'Sec-Fetch-Mode': 'cors',
    'Content-Type': 'application/json',
  },
  // API-DEV
  baseUrl: 'https://api-dev.acc.co.nz/api/v1/bic/',
  // API-TEST
  // baseUrl: 'https://api-test.acc.co.nz/api/v1/',
  init(config){
    if (config && 'apiUrl' in config) {
      if ('apiKey' in config && config.apiKey) {
        this.headers.apikey = config.apiKey;
      }
      this.baseUrl = config.apiUrl;
    }
  },
  async getIndustries() {
    const url = `${this.baseUrl}industries?filter[order]=name`;
    return Transport.get(url, this.headers);     
  },
  async getSectors(industry) {
    const url = `${this.baseUrl}industries/${industry}/divisions?filter[order]=name`;
    return Transport.get(url, this.headers);
  },
  async getCategories(sector) {
    const url = `${this.baseUrl}divisions/${sector}/classes?filter[order]=name`;
    return Transport.get(url, this.headers);
  },
  async getCodesByTerm(term) {
    const url = `${this.baseUrl}bics/search?term=${term}&filter[include]=cu&filter[include]=anzsic&filter[include]=bicrefs&filter[include]=historyBic`;
    return Transport.get(url, this.headers);
  },
  async getCodesByClassId(classId) {
    const url = `${this.baseUrl}bics?filter[order]=desc&filter[where][classId]=${classId}&filter[include]=cu&filter[include]=anzsic&filter[include]=bicrefs&filter[include]=historyBic`;
    return Transport.get(url, this.headers);
  },
  async getCodeById(bicId) {
    const url = `${this.baseUrl}bics/${bicId}?filter[include]=cu&filter[include]=anzsic&filter[include]=historyBic`;
    return Transport.get(url, this.headers);
  },
  // codes is an array of BIC codes - usually the bicsSelected property of the state (eg: ['G425140', 'G426010'])
  // async getCodesByCodes(codes) {
  //   const codeFilter = this.buildCodeFilter(codes);
  //   const url = `${this.baseUrl}/bic/bics?${codeFilter}&filter[include]=cu&filter[include]=anzsic&filter[include]=bicrefs&filter[include]=historyBic`;
  //   console.log(url);
  //   const response = await Transport.get(url, this.headers);
  //   return response;
  // },
  // TODO: see if we alter all the "get" functions according to the pattern below
  getSelectedCodes(codes) {
    const codeFilter = this.buildCodeFilter(codes.bicsSelected);
    const includeFilter = this.buildIncludeFilter(['cu', 'anzsic', 'bicrefs', 'historyBic']);
    return `${this.baseUrl}bics?${codeFilter}&${includeFilter}`;
  },
  // filter[where][or][0][code]=G431050&filter[where][or][1][code]=G427907&filter[where][or][2][code]=G421110
  buildCodeFilter(codes) {
    return codes.map((code, idx) => `filter[where][or][${idx}][code]=${code}`).join('&');
  },
  buildIncludeFilter(fields) {
    return fields.map((field) => `filter[include]=${field}`).join('&');
  },
  // const url = `${this.baseUrl}bic/industries?filter[order]=name`,
  async get(type, payload) {
    const url = this[`get${type}`](payload);
    return Transport.get(url, this.headers);
  },
  getSectorDetails(payload) {
    return `${this.baseUrl}divisions/${payload.sector}`;
  },
  getCategoryDetails(payload) {
    return `${this.baseUrl}classes/getDivisionAndIndustry?classId=${payload.category}`;
  }
};

const ssConfig = window.ssConfig || {};
dataService.init(ssConfig);

export default dataService;
